<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <div class="overview-wrap">
          <h2 class="title-1">Banner үүсгэх</h2>
        </div>
      </div>
    </div>

    <div class="row my-3">
      <div class="card w-100">
        <div class="card-body">
          <div class="row form-group">
            <div class="col-4 offset-1">
              <div class="card w-100">
                <div class="card-header">Web banner*</div>
                <div class="card-body banner-container banner-height">
                  <img class="mh-100" v-bind:src="getImg(false)" alt>
                </div>
                <div class="custom-file">
                  <input
                    type="file"
                    accept="image/*"
                    class="custom-file-input"
                    id="inputGroupFile01"
                    aria-describedby="inputGroupFileAddon01"
                    @change="onImageInput($event, false)"
                    :class="{ 'form-control is-invalid': $v.pcimage.$error }"
                  >
                  <div class="invalid-feedback">{{ this.getErrorMsg('pcImage')[0] }}</div>
                  <label class="custom-file-label" for="inputGroupFile01">Файл сонгох</label>
                </div>
              </div>
            </div>
            <div class="col-4 offset-1">
              <div class="card w-100">
                <div class="card-header">Mobile banner*</div>
                <div class="card-body banner-container banner-height">
                  <img class="mh-100" v-bind:src="getImg(true)" alt>
                </div>
                <div class="custom-file">
                  <input
                    type="file"
                    accept="image/*"
                    class="custom-file-input"
                    id="inputGroupFile01"
                    aria-describedby="inputGroupFileAddon01"
                    @change="onImageInput($event, true)"
                    :class="{ 'form-control is-invalid': $v.mobileimage.$error }"
                  >
                  <div class="invalid-feedback">{{ this.getErrorMsg('mobileImage')[0] }}</div>
                  <label class="custom-file-label" for="inputGroupFile01">Файл сонгох</label>
                </div>
              </div>
            </div>
          </div>
          <div class="row form-group">
            <div class="col-3">
              <label for="text-input" class="form-control-label">Name*</label>
            </div>
            <div class="col-9">
              <input
                v-model="name"
                type="text"
                id="text-input"
                class="form-control"
                v-on:input="onChangeHandler('name', $v.name)"
                :class="{ 'form-control is-invalid': $v.name.$error }"
              >
              <div class="invalid-feedback">{{ this.getErrorMsg('name')[0] }}</div>
            </div>
          </div>
          <div class="row form-group">
            <div class="col-3">
              <label class="form-control-label">Start date*</label>
            </div>
            <div class="col-9">
              <input
                v-model="startdate"
                class="form-control"
                type="date"
                v-on:input="onChangeHandler('startDate', $v.startdate)"
                :class="{ 'form-control is-invalid': $v.startdate.$error }"
              >
              <div class="invalid-feedback">{{ this.getErrorMsg('startDate')[0] }}</div>
            </div>
          </div>
          <div class="row form-group">
            <div class="col-3">
              <label class="form-control-label">End date*</label>
            </div>
            <div class="col-9">
              <input
                v-model="enddate"
                class="form-control"
                type="date"
                v-on:input="onChangeHandler('endDate', $v.enddate)"
                :class="{ 'form-control is-invalid': $v.enddate.$error }"
              >
              <div class="invalid-feedback">{{ this.getErrorMsg('endDate')[0] }}</div>
            </div>
          </div>
          <div class="row form-group">
            <div class="col-3">
              <label for="text-input" class="form-control-label">Link (optional)</label>
            </div>
            <div class="col-9">
              <input
                type="text"
                id="text-input"
                name="text-input"
                class="form-control"
                v-model="link"
                v-on:input="onChangeHandler('url', $v.link)"
                :class="{ 'form-control is-invalid': $v.link.$error }"
              >
              <div class="invalid-feedback">{{ this.getErrorMsg('url')[0] }}</div>
            </div>
          </div>
        </div>
        <div class="card-footer d-flex justify-content-end">
          <router-link to="/banner">
            <button type="submit" class="btn btn-primary mx-2">Буцах</button>
          </router-link>
          <button @click="onSubmit" type="submit" class="btn btn-success">
            <i class="fa fa-dot-circle-o"></i> Хадгалах
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BannerService from "@/services/BannerService";
import ImageUploadService from "@/services/ImageUploadService";
import Form from "@/mixins/Form.js";

export default {
  name: "BannerCreate",

  mixins: [Form],

  data() {
    return {
      name: "",
      pcimage: "",
      mobileimage: "",
      startdate: new Date().toISOString().split("T")[0],
      enddate: "",
      link: ""
    };
  },

  validations: {
    name: {
      serverFailed: function() {
        return !this.hasServerError("name");
      }
    },
    pcimage: {
      serverFailed: function() {
        return !this.hasServerError("pcImage");
      }
    },
    mobileimage: {
      serverFailed: function() {
        return !this.hasServerError("mobileImage");
      }
    },
    startdate: {
      serverFailed: function() {
        return !this.hasServerError("startDate");
      }
    },
    enddate: {
      serverFailed: function() {
        return !this.hasServerError("endDate");
      }
    },
    link: {
      serverFailed: function() {
        return !this.hasServerError("url");
      }
    }
  },

  methods: {
    getImg(isMobile) {
      let img = require("@/assets/images/noimg.jpg");
      if (isMobile) return this.mobileimage != "" ? this.mobileimage : img;
      else return this.pcimage != "" ? this.pcimage : img;
    },

    serverRequest: BannerService.createBanner,

    successHandler(response) {
      if (response.data.payload.toast !== null)
        this.showToast(response.data.payload.toast);

      this.$router.push("/banner");
    },

    createJsonData() {
      const data = JSON.parse("{}");
      data.name = this.name;
      data.pcImage = this.pcimage;
      data.mobileImage = this.mobileimage;
      data.startDate = this.startdate;
      data.endDate = this.enddate;
      if (this.link != "") data.url = this.link;
      return data;
    },

    onImageInput(event, isMobile) {
      if (event.target.files[0] != null) {
        const data = new FormData();
        data.append("image", event.target.files[0]);
        ImageUploadService.uploadImage(data).then(response => {
          if (isMobile) {
            this.mobileimage = response.data;
            this.onChangeHandler("mobileImage", this.$v.mobileimage);
          } else {
            this.pcimage = response.data;
            this.onChangeHandler("pcImage", this.$v.pcimage);
          }
        });
      }
    }
  }
};
</script>